import { FormControl } from '@angular/forms';


// please also see https://medium.com/@srik913/angular-validation-error-messages-display-using-directives-415a7616caf3
// for directive way to handle error message
export class FormControlWithError extends FormControl {
    getError(): string {
        if (this.invalid) {
            const keys = Object.keys(this.errors);
            for (const errKey of keys) {
                // only return first error
                // it is return error key now, better to return more meanful message
                return errKey;
            }
            return 'unknow error';
        }
        return '';
    }

    getErrorClass(): string {
        if (this.invalid) {
            return 'validation-error';
        }
        return '';
    }
}
